import { Card } from "react-bootstrap";
import TrafficSourcesAutocomplete from "../components/TrafficSourcesAutocomplete";
import { FiltersInitialStateHelper } from "./FiltersInitialState";
import { FiltersEventsHelper, isDateGroupBy } from "./FiltersEventsHelper";
import { faQuestionCircle } from "@fortawesome/free-regular-svg-icons/faQuestionCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Alert from 'react-bootstrap/Alert';
import DateRangeSelector from "../components/DateRangeSelector";
import CountriesAutocomplete from "../components/CountriesAutocomplete";
import TrafficTypeAutocomplete from "../components/TrafficTypeAutocomplete";
import PlacementsAutocomplete from "../components/PlacementsAutocomplete";
import GroupByAutocomplete from "../components/GroupByAutocomplete";
import ProductsAutocomplete from "../components/ProductsAutocomplete";
import CampaignsAutocomplete from "../components/CampaignsAutocomplete";
import { TrafficSourceResponseDto, ResponseStatus,ProductsCampaignsDto,UserPermissions, QueryFlags, SortState, DateModes, IdName, ColumnIds, IncludeExclude } from "../utils/types";
import { PageState, PublisherOrSiteOption,ProductRecord,PlacementResponseDto,CLinkOwnerResponseDto,CLinkOwnerOption } from "../utils/types";
import { CampaignRecord,PlacementRecord} from "../utils/types";
import { getGroupByArray} from "../utils/misc";
import { CommonRequests } from "../common/CommonRequests";
import StateHelper from "../utils/StateHelper";
import CLinkOwnersAutocomplete from "../components/CLinkOwnersAutocomplete";
import QueryFlagsAutocomplete from "../components/QueryFlagsAutocomplete";
import dayjs from "../utils/dayjs";
import { PagesHelper } from "./PagesHelper";
import LoadingMessage from "../components/notifications/LoadingMessage";
import { isAllowedFilterField } from "../utils/UserHelper";

function UnableToLoadMessage (props : any) {
    const alertStyle = {marginBottom : '1px', height: '30px', lineHeight:'30px' ,padding: '0px 15px'};
    const fontStyle = { fontSize: '90%', color : 'red'};
    return <Alert variant="dark" style={alertStyle} className="border border-danger">
                <span style={fontStyle}>{props.message}</span> 
            </Alert>;
}

function placementsOnChange(selectedValues: any, page : string) {
    const pageState : PageState = StateHelper.getPageState();
    FiltersEventsHelper.placementsDropDownOnChange(page, pageState, selectedValues);
}

function trafficTypeOnChange(selectedValues: any, page : string) {
    const pageState : PageState = StateHelper.getPageState();
    FiltersEventsHelper.trafficTypeOnChange(page, pageState, selectedValues);
}

function countryOnChange(selectedValues: any, page : string) {
    const pageState : PageState = StateHelper.getPageState();
    FiltersEventsHelper.countriesDropdownOnChange(page, pageState, selectedValues);
}

function dateRangeOnChange(start: dayjs.Dayjs, end: dayjs.Dayjs, dateMode: DateModes) {
    const pageState : PageState = StateHelper.getPageState();
    const sortState:SortState = StateHelper.getSortState();
    FiltersEventsHelper.dateRangeOnChange(pageState.page, pageState, sortState, start, end, dateMode);
};

function publisherOnChange(selectedValues: PublisherOrSiteOption[], page : string) {
    const pageState : PageState = StateHelper.getPageState();
    FiltersEventsHelper.trafficSourcesDropDownOnChange(page, pageState, selectedValues);
  }

function groupByOnChange(selectedValues: IdName[], page : string) {
    const pageState : PageState = StateHelper.getPageState();
    const sortState:SortState = StateHelper.getSortState();
    FiltersEventsHelper.groupByOnChange(page, pageState, sortState, selectedValues);
}

function productsOnChange(selectedValues: ProductRecord[], page : string) {
    const pageState : PageState = StateHelper.getPageState();
    FiltersEventsHelper.productsDropdownOnChange( page, pageState, selectedValues);
}

function campaignsOnChange(selectedValues: CampaignRecord[], page: string) {
    const pageState : PageState = StateHelper.getPageState();
    FiltersEventsHelper.campaignsDropdownOnChange(page, pageState, selectedValues)    ;
}

function cLinkOwnersOnChange(selectedValues: CLinkOwnerOption[], page: string, cLinksRef:any, searchCLinkOwnersFunction:(query:string) => void) {
    cLinksRef.current.setState({...cLinksRef.current.state, text: ""});
    searchCLinkOwnersFunction("");
    const pageState : PageState = StateHelper.getPageState();
    FiltersEventsHelper.cLinksDropdownOnChange(page, pageState, selectedValues);
}

function queryFlagsOnChange(selectedValues: QueryFlags[], page : string) {
    const pageState : PageState = StateHelper.getPageState();
    FiltersEventsHelper.queryFlagsDropDownOnChange(page, pageState, selectedValues);
}

function includeExcludeOnChange(field: string, includeExclude: IncludeExclude, page: string) {
    const pageState:PageState = StateHelper.getPageState();
    const values = (pageState as any)[field];
    let propertyIncludeExclude = field + 'IncludeExclude';
    if (field === 'publishers') {
        propertyIncludeExclude = 'placementsIncludeExclude';
    } else if (field === 'productIds') {
        propertyIncludeExclude = 'productsIncludeExclude';
    }
    (pageState as any)[propertyIncludeExclude] = includeExclude;

    if (values && values.length > 0) {
        const searchFuntion = StateHelper.getSearchFuntion(page);
        searchFuntion();
    }
}

export const FiltersHelper = {
    getCampaignsCard : function(currentUser : any, page : string, campaignsRef : any, dto : ProductsCampaignsDto){

        const validUser : boolean = currentUser && currentUser.filterFields;
        if( ! validUser ){
            return null;
        }

        const showFilter : boolean = currentUser.filterFields.includes("campaignsInclude") || currentUser.permissions.includes(UserPermissions.apptapDataCampaignSourceAlias);
        if( ! showFilter ){
            return null;
        }

        let component : any = null;
        if( dto ){
            const showError : boolean = dto.status === ResponseStatus.ERROR;

            if( showError ){
                component= <UnableToLoadMessage message="Unable to load Campaigns." />;
            }
            else{
                const pageState : PageState = StateHelper.getPageState();
                const campaignsSelected: CampaignRecord[] = FiltersInitialStateHelper.getCampaignsState(dto.campaignsResponse);
                const cmbCampaigns =  <CampaignsAutocomplete id="cmbCampaigns" 
                                        onChange={(e : any) => campaignsOnChange(e , page)} 
                                        options={dto.campaignsResponse} 
                                        products={dto.productsResponse} 
                                        selected={campaignsSelected}  
                                        reactRef={campaignsRef} 
                                        disabled={false}
                                        hasCampaignsPermissions={currentUser.permissions.includes(UserPermissions.apptapDataCampaigns)}
                                        key={pageState.campaignsIncludeExclude + "-" + campaignsSelected.length}
                                        defaultIncludeExclude={pageState.campaignsIncludeExclude}
                                        includeExcludeOnChange={(e : any) => includeExcludeOnChange('campaigns', e, page)}
                                        />;

                component = cmbCampaigns;
            }
        }
        else {
            component = <LoadingMessage message="Loading Campaigns..." />;
        }

        return (
            <Card style={{border: "none"}}>
                <Card.Title style={{ fontSize: "100%", whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "clip"}}>Campaign Sources and Campaigns</Card.Title>
                {component}
            </Card>    
        );
    },

    getProductsCard : function(currentUser : any, page : string, productsRef : any, dto : ProductsCampaignsDto){
        const validUser : boolean = currentUser && currentUser.filterFields;
        if( ! validUser ){
            return null;
        }

        const showFilter : boolean = currentUser.filterFields.includes("productIds") || currentUser.filterFields.includes("productIdsInclude");
        if( ! showFilter ){
            return null;
        }

        let component : any = null;
        if( dto ){
            const showError : boolean = dto.status === ResponseStatus.ERROR;

            if( showError ){
                component= <UnableToLoadMessage message="Unable to load Products" />;
            }
            else{
                const pageState : PageState = StateHelper.getPageState();
                const productsSelected : ProductRecord[] = FiltersInitialStateHelper.getProductsState(dto.productsResponse);
                const cmbProducts = <ProductsAutocomplete 
                                              id="cmbProducts" 
                                              onChange={(e : any) => productsOnChange(e, page)} 
                                              options={dto.productsResponse}  
                                              selected={productsSelected} 
                                              reactRef={productsRef}
                                              disabled={false}
                                              key={pageState.productsIncludeExclude + "-" + productsSelected.length}
                                              defaultIncludeExclude={pageState.productsIncludeExclude}
                                              includeExcludeOnChange={(e : any) => includeExcludeOnChange('productIds', e, page)}
                                            />; 
      
                component = cmbProducts;
            }
        }
        else {
          component = <LoadingMessage message="Loading Products..."/>; 
        }

        return (
            <Card style={{border: "none"}}>
                <Card.Title style={{ fontSize: "100%"}}>Products (Apps, Brands)</Card.Title>
                {component}
            </Card>
        );
    },

    getGroupByCard : function(currentUser : any, page : string, groupByRef : any){
        const allowedGroupByFields : string[] = currentUser && currentUser.groupByFields ? currentUser.groupByFields : [];
        const groupByState = FiltersInitialStateHelper.getGroupByState(page,allowedGroupByFields);
        let GROUP_BY_ARRAY = getGroupByArray(page,allowedGroupByFields,groupByState);

        const pageState = StateHelper.getPageState();

        if (pageState.pivotBy) {
            // remove date-based options since the pivot doesn't allow for toggling between using the group-by control
            GROUP_BY_ARRAY = GROUP_BY_ARRAY.filter((option) => !isDateGroupBy(option.id));
        }

        const datesMonthBounded = pageState.dateStart.isSame(pageState.dateStart.startOf("month"), "day")
                && pageState.dateEnd.isSame(pageState.dateEnd.endOf("month").startOf("day"), "day");
        const datesWeekBounded = pageState.dateStart.isSame(pageState.dateStart.startOf("isoWeek"), "day")
                && pageState.dateEnd.isSame(pageState.dateEnd.endOf("isoWeek"), "day");

        // if the current date range is not week bounded, then don't allow the week group-by option
        if ( !datesWeekBounded ) {
            GROUP_BY_ARRAY = GROUP_BY_ARRAY.filter((option) => option.id !== ColumnIds.week);
        }

        // if the current date range is not month bounded, then don't allow the month group-by option
        if ( !datesMonthBounded ) {
            GROUP_BY_ARRAY = GROUP_BY_ARRAY.filter((option) => option.id !== ColumnIds.month);
        }

        // if too many days are included in this date range, donm't allow the day or week group-by options
        if ( pageState.dateEnd.diff(pageState.dateStart, "days") > 92 ) {
            GROUP_BY_ARRAY = GROUP_BY_ARRAY.filter((option) => option.id !== ColumnIds.date && option.id !== ColumnIds.week);
        }

        return (
            <Card style={{border: "none"}}>
                <Card.Title style={{ fontSize: "100%", height: "20px" }}>Group By</Card.Title>
                <GroupByAutocomplete id="cmbGroupBy"  onChange={(e : any) => groupByOnChange(e, page)} selected={groupByState} options={GROUP_BY_ARRAY} reactRef={groupByRef} />
            </Card>    
        );
    },

    getPublisherPlacementsCard: function(
            currentUser : any,
            page : string,
            placementsRef : any,
            trafficSourceResponseDto : TrafficSourceResponseDto,
            setPlacementsResponseDto : any,
            placementResponseDto: PlacementResponseDto,
            placementsIsLoading: any,
            setPlacementsIsLoading : any) {

        const validUser : boolean = currentUser && currentUser.filterFields;
        if( ! validUser ){
            return null;
        }

        const showFilter : boolean = currentUser.filterFields.includes("placementsInclude") ;
        if( ! showFilter ){
            return null;
        }

        let placementOptions : PlacementRecord[] = [];
        let selectedPlacementRecords : PlacementRecord[] = [];

        const searchPlacementsFunction = ( query : string) => {
            CommonRequests.searchPlacements(query, setPlacementsResponseDto, setPlacementsIsLoading)
        };
        
        if( placementResponseDto && placementResponseDto.status === ResponseStatus.ERROR ){
            selectedPlacementRecords = [];
            placementOptions =  placementResponseDto ? placementResponseDto.placementsResponse : [];
        }
        else {
            selectedPlacementRecords = FiltersInitialStateHelper.getPublisherPlacementsInitialState(trafficSourceResponseDto);
            placementOptions =  placementResponseDto ? placementResponseDto.placementsResponse : [];
        }
        const pageState : PageState = StateHelper.getPageState();

        return (
            <Card style={{border: "none"}}>
                <Card.Title style={{ fontSize: "100%"}}>Publisher Placements</Card.Title>
                <PlacementsAutocomplete 
                    onChange={(e : any) => placementsOnChange(e, page)} 
                    selected={selectedPlacementRecords} 
                    options={placementOptions}
                    reactRef={placementsRef} 
                    searchPlacements={searchPlacementsFunction} 
                    placementsIsLoading={placementsIsLoading}
                    key={pageState.placementsIncludeExclude + "-" + selectedPlacementRecords.length}
                    defaultIncludeExclude={pageState.placementsIncludeExclude}
                    includeExcludeOnChange={(e : any) => includeExcludeOnChange('placements', e, page)}
                    useIncludeExclude={isAllowedFilterField("placementsExclude")}
                />
            </Card>
        );
    },
    
    getTrafficTypesCard : function(currentUser : any, page : string, trafficTypesRef : any) : any {
        const validUser : boolean = currentUser && currentUser.filterFields;
        if( ! validUser ){
            return null;
        }

        const showFilter : boolean = currentUser.filterFields.includes("trafficTypes") || currentUser.filterFields.includes("trafficTypesInclude") ;
        if( ! showFilter ){
            return null;
        }

        const trafficTypesState = FiltersInitialStateHelper.getTrafficTypesState();
        const pageState : PageState = StateHelper.getPageState();

        return(
            <Card style={{border: "none"}}>
                <Card.Title style={{ fontSize: "100%"}}>Traffic Types</Card.Title>
                <TrafficTypeAutocomplete
                    onChange={(e : any) => trafficTypeOnChange(e, page)}
                    selected={trafficTypesState}
                    reactRef={trafficTypesRef}
                    key={pageState.trafficTypesIncludeExclude + "-" + trafficTypesState.length}
                    defaultIncludeExclude={pageState.trafficTypesIncludeExclude}
                    includeExcludeOnChange={(e: any) => includeExcludeOnChange('trafficTypes', e, page)}
                />
            </Card>
        );
    },

    getCountriesCard : function(currentUser : any, page : string, countriesRef : any) : any {
        const validUser : boolean = currentUser && currentUser.filterFields;
        if( ! validUser ){
            return null;
        }

        const showFilter : boolean = currentUser.filterFields.includes("countries") || currentUser.filterFields.includes("countriesInclude");
        if( ! showFilter ){
            return null;
        }

        const countriesState = FiltersInitialStateHelper.getCountriesState();
        const pageState : PageState = StateHelper.getPageState();

        return(
            <Card style={{border: "none"}}>
                <Card.Title style={{ fontSize: "100%"}}>Countries</Card.Title>
                <CountriesAutocomplete
                    onChange={(e : any) => countryOnChange(e, page)}
                    selected={countriesState}
                    reactRef={countriesRef}
                    key={pageState.countriesIncludeExclude + "-" + countriesState.length}
                    useIncludeExclude
                    defaultIncludeExclude={pageState.countriesIncludeExclude}
                    includeExcludeOnChange={(e : any) => includeExcludeOnChange('countries', e, page)}
                />
            </Card>
        );
    },

    getDateRangeCard : function(currentUser : any, page : string) : any {
        const validUser : boolean = currentUser && currentUser.filterFields;
        if( ! validUser ){
            return null;
        }

        const showFilter : boolean = currentUser.filterFields.includes("dateStart") || currentUser.filterFields.includes("dateEnd");
        if( ! showFilter ){
            return null;
        }

        const dateRange = FiltersInitialStateHelper.getDateRangeState();

        const statusIcon = <FontAwesomeIcon icon={faQuestionCircle} style={{color: "#9fcdff"}} fixedWidth></FontAwesomeIcon>;

        const title = "Dates";
        return (
          <Card  style={{border: "none"}}>
            <Card.Title style={{ fontSize: "100%", height: "20px" }}>
                {title}
                <OverlayTrigger
                    key="dates-tooltip-overlay"
                    placement="right"
                    overlay={( props ) => {
                        const todayUTC = dayjs.utc().format("YYYY-MM-DD");
                        const todayLocal = dayjs().format("YYYY-MM-DD");
                        return (                        
                            <Tooltip {...props} id="dates-tooltip">
                                <div>Reporting is in GMT (UTC).</div>
                                <div>For reporting purposes, "today" is: {todayUTC}.</div>
                                {todayLocal === todayUTC ? null : <div>Local "today" is {todayLocal}.</div> }
                            </Tooltip>
                        );
                    }}>
                    <span>{statusIcon}</span>
                </OverlayTrigger>
            </Card.Title>
            <DateRangeSelector onChange={dateRangeOnChange} startDate={dateRange.dateStart} endDate={dateRange.dateEnd}/>
          </Card>             
        );
    },

    getTrafficSourcesCard : function(
        currentUser: any, 
        page: string, 
        trafficSourceResponseDto: TrafficSourceResponseDto, 
        trafficSourcesRef: any): any {

        const validUser : boolean = currentUser && currentUser.filterFields;
        if( ! validUser ){
            return null;
        }
        
        const showFilter : boolean = currentUser.filterFields.includes("placementsInclude");
        if( ! showFilter ){
            return null;
        }

        const pageState : PageState = StateHelper.getPageState();
        const isTrafficSourceAutocompleteDisabled = pageState.placements && pageState.placements.length > 0;
        const onMenuToggle = (isOpen:boolean) => {
            if (!isOpen) trafficSourcesRef.current.setState((prevState:any) => ({...prevState,text: ""}));
        }

        let cmbTrafficSources : any = null;
 
        if ( trafficSourceResponseDto ){
            const showError : boolean = trafficSourceResponseDto.status === ResponseStatus.ERROR;
            if( showError ){
               cmbTrafficSources = <UnableToLoadMessage message="Unable to load Traffic Sources" />;
            }
            else if( trafficSourceResponseDto.publishersArray &&  trafficSourceResponseDto.publishersArray.length > 0 ){
                const publishersArray :  PublisherOrSiteOption[] = trafficSourceResponseDto.publishersArray;
                const selected : PublisherOrSiteOption[] = FiltersInitialStateHelper.getTrafficSourceState(publishersArray);
                cmbTrafficSources = 
                    <TrafficSourcesAutocomplete 
                        onChange={(e : PublisherOrSiteOption[]) => publisherOnChange(e,page)} 
                        options={publishersArray} 
                        selected={selected}
                        selectedForCheckboxes={selected}
                        reactRef={trafficSourcesRef} 
                        disabled={isTrafficSourceAutocompleteDisabled}
                        onMenuToggle={onMenuToggle}
                        useIncludeExclude
                        defaultIncludeExclude={pageState.placementsIncludeExclude}
                        includeExcludeOnChange={(e : any) => includeExcludeOnChange('publishers', e, page)}
                        multiple
                        useCheckbox
                    />;
            }
        }            
        else {
            cmbTrafficSources = <LoadingMessage message="Loading Traffic Sources..."/>;
        }

        return (
            <Card style={{border: "none"}}>
                <Card.Title style={{ fontSize: "100%"}}>Traffic Sources</Card.Title>
                {cmbTrafficSources}
            </Card>
            );

    },

    getCLinkOwnersCard : function(
        currentUser : any,
        page : string,
        cLinksRef : any,
        cLinkOwnerstsIsLoading : boolean,
        setCLinkOwnersIsLoading : any,
        dto : CLinkOwnerResponseDto,
        setCLinkOwnersDto : any,
        trafficSourceResponseDto: any,
        mostFrequentTags:string[]) {

        const validUser : boolean = currentUser && currentUser.filterFields;
        if( ! validUser ){
            return null;
        }

        const showFilter : boolean = currentUser.filterFields.includes("clinksInclude") && (currentUser.permissions.includes(UserPermissions.appptapDataCLinks) || currentUser.permissions.includes(UserPermissions.appptapDataCLinksOwners));
        if( ! showFilter ){
            return null;
        }

        const searchCLinkOwnersFunction = async( query : string) => {
            setCLinkOwnersIsLoading(true);
            const results = await CommonRequests.searchCLInkOwners(query);
            if (results) {
                // support_tags/notes
                // if (query) {
                //     mostFrequentTags.forEach((tag:string) => {
                //         if (tag.includes(query)) {
                //             const a:CLinkOwnerOption = {
                //                 record: "#" + tag,
                //                 key: tag,
                //                 text: tag,
                //                 id: tag
                //             }
                //             results.cLinksOwnerResponse.unshift(a);
                //         }
                //     })
                // }
                setCLinkOwnersIsLoading(false);
                setCLinkOwnersDto(results);
            }
        };
        const placeholder = currentUser.permissions.includes(UserPermissions.appptapDataCLinksOwners) ? "Specify cLinkID or Owner to search for" : "Specify cLinkID to search for";

        let component : any = null;
        const cLinkOwnersOptions: CLinkOwnerOption[] = dto && dto.cLinksOwnerResponse ? dto.cLinksOwnerResponse as CLinkOwnerOption[] : [];
        const cLinkOwnerSelected = FiltersInitialStateHelper.getCLinkOwnersState(page, cLinkOwnersOptions);
        const pageState: PageState = StateHelper.getPageState();

        if (dto) {
            component = <CLinkOwnersAutocomplete 
                            id="cmbCLinks" 
                            onChange={(e : any) => cLinkOwnersOnChange(e, page, cLinksRef, searchCLinkOwnersFunction)} 
                            options={cLinkOwnersOptions} 
                            selected={cLinkOwnerSelected}
                            onInputChange={searchCLinkOwnersFunction}
                            searchCLinkOwners={searchCLinkOwnersFunction} 
                            reactRef={cLinksRef} 
                            disabled={false}
                            placeholder={placeholder}
                            trafficSourceResponseDto={trafficSourceResponseDto}
                            clinkOwnersIsLoading={cLinkOwnerstsIsLoading}
                            useIncludeExclude={isAllowedFilterField("clinksExclude")}
                            key={pageState.cLinksIncludeExclude + "-" + cLinkOwnerSelected.length}
                            defaultIncludeExclude={pageState.cLinksIncludeExclude}
                            includeExcludeOnChange={(e : any) => includeExcludeOnChange('cLinks', e, page)}
                        />;
        } else {
            component = <LoadingMessage message="Loading Clinks and Owners.."/>;
        }

        return (
            <Card style={{border: "none"}}>
                <Card.Title style={{ fontSize: "100%", height: "20px", whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "clip"}}>cLinks</Card.Title>
                {component}
            </Card>
        );
    },

    getQueryFlagsCard: function(currentUser : any, page : string, queryFlagsRef : any) : any {
        const hasCampaignsPermissions : boolean = currentUser && currentUser.permissions && currentUser.permissions.includes(UserPermissions.apptapDataCampaigns);
        if ( !hasCampaignsPermissions ) {
            return null;
        }

        const queryFlagsState = FiltersInitialStateHelper.getQueryFlagsState();

        return(
            <Card  style={{border: "none"}}>
            <Card.Title style={{ fontSize: "100%", height: "20px" }}>Query Flags</Card.Title>
                <Card>
                    <QueryFlagsAutocomplete
                        onChange={(e : QueryFlags[]) => queryFlagsOnChange(e,page)} 
                        selected={queryFlagsState}
                        reactRef={queryFlagsRef}
                    />
                </Card>
            </Card>
        );
    },

    checkRequiredGroupByAndPermissions: function(currentUser : any, page: string) {
        const allowedGroupByFields : string[] = currentUser && currentUser.groupByFields ? currentUser.groupByFields : [];
        const groupByState = FiltersInitialStateHelper.getGroupByState(page,allowedGroupByFields);
        const GROUP_BY_ARRAY = getGroupByArray(page,allowedGroupByFields,groupByState);

        const pageState : PageState = StateHelper.getPageState();
        const prevGroupBy = pageState.groupBy;
        pageState.groupBy = "";
        groupByState.forEach((groupBy) => {
            if (!GROUP_BY_ARRAY.find((grooupByOption:any) => grooupByOption.id === groupBy.id)) return;
            pageState.groupBy = pageState.groupBy ?  pageState.groupBy + "," + groupBy.id : pageState.groupBy + groupBy.id;
        });
        GROUP_BY_ARRAY.forEach((groupBy) => {
            if (groupBy.required && !groupByState.includes(groupBy)) {
                if (!pageState.groupBy) {
                    pageState.groupBy = groupBy.id;
                } else {
                    pageState.groupBy = groupBy.id + "," + pageState.groupBy;
                }
            }
        });

        if (prevGroupBy !== pageState.groupBy) {
            // use of history replace instead of push to keep browser back and forward working
            PagesHelper.historyReplaceFromPageState();
        }
    }
};